import React from 'react';
import { motion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  as?: 'div' | 'li' | 'section';
};
const EASE = [0.23, 1, 0.32, 1] as const;
export function Reveal({
  children,
  delay = 0,
  className,
  as = 'div'
}: RevealProps) {
  const MotionTag = motion[as];
  return <MotionTag className={className} initial={{
    opacity: 0,
    y: 14
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.28,
    ease: EASE,
    delay
  }} data-id="element-130" data-mp="3gg7ekokr01s1">
      {children}
    </MotionTag>;
}